
import PublicRoutes from "../public/routes/public";
import {AdminRoutes } from "../admin/routes/admin";


export const routes = [
  // ...DashboardRoute,
];

export const publicRoutes = [...PublicRoutes];
export const adminRoutes = [...AdminRoutes ];

